/* eslint-disable @typescript-eslint/no-explicit-any */
import { callErrorMsg } from 'helpers/errorMsg'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { getPPNList } from 'features/Product/services/productAdd'

import { getProductDetailApi } from 'features/Product/services/productMasterDetail'
import { putUpdateProductApi } from 'features/Product/services/product'

import { type PutUpdateProductStatusPayloadType } from 'features/Product/@types/ProductAdd'

import { deleteLabelOnProductApi, getDetailDiscoveryLabel, getProductLabel } from 'utils/api'
import { AxiosResponse } from 'axios'
import { DiscoveryLabelType } from 'redux/productLabel'
import {
  SLICE_NAME_PRODUCT_MASTER_DETAIL,
  setProductDetail,
  setIsLoading,
  setPPNList,
  setProductLabelImage,
  setProductLabelPromotion,
} from './slice'

export const fetchProductDetail = createAsyncThunk(
  `${SLICE_NAME_PRODUCT_MASTER_DETAIL}/fetchDetail`,
  async (productId: number, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await getProductDetailApi(productId)
      dispatch(setProductDetail(data.data))
      dispatch(setIsLoading(false))
      return false
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const putUpdateProduct = createAsyncThunk(
  `${SLICE_NAME_PRODUCT_MASTER_DETAIL}/putUpdateProduct`,
  async (
    { id, payload }: { id: number; payload: PutUpdateProductStatusPayloadType },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      await putUpdateProductApi(id, payload)
      dispatch(fetchProductDetail(id))
      dispatch(setIsLoading(false))
      return true
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const fetchPPNList = createAsyncThunk(
  `${SLICE_NAME_PRODUCT_MASTER_DETAIL}/fetchPPNList`,
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const response = await getPPNList()
      dispatch(setPPNList(response.data.data))
      dispatch(setIsLoading(false))
      return true
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const deleteLabelOnProduct = createAsyncThunk(
  `${SLICE_NAME_PRODUCT_MASTER_DETAIL}/deleteLabelOnProduct`,
  async ({ productId, labelId }: { productId: number; labelId: number }, { rejectWithValue }) => {
    try {
      const response = await deleteLabelOnProductApi(productId, labelId)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const fetchListLabelOnProduct = createAsyncThunk(
  `${SLICE_NAME_PRODUCT_MASTER_DETAIL}/fetchListLabelOnProduct`,
  async (productId: number, { dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const {
        data: { content },
      } = (await getProductLabel(productId)) as AxiosResponse<{
        content: {
          productId: number
          labelId: number
          isPrimary: boolean
        }[]
      }>

      if (content.length) {
        const responses = await Promise.all(
          content.map(
            (item) =>
              getDetailDiscoveryLabel(item.labelId) as Promise<AxiosResponse<DiscoveryLabelType>>,
          ),
        )

        const labelImage = responses.find((res) => /image/i.test(res.data.masterLabelTypeName))
        const labelPromotion = responses.find((res) =>
          /promotion/i.test(res.data.masterLabelTypeName),
        )

        dispatch(setProductLabelImage(labelImage?.data || null))
        dispatch(setProductLabelPromotion(labelPromotion?.data || null))
      }
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
    }
  },
)
